import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

const BankAccountUpdateSuccess = ({ closeModal, confirmAction = closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('BankAccountUpdateSuccess.title')}>
      <p>{t('BankAccountUpdateSuccess.info')}</p>
      <ModalActions>
        <Button onClick={confirmAction}>{t('BankAccountUpdateSuccess.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default BankAccountUpdateSuccess;
